"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _immutable = require("immutable");

var _Products = require("hub-pickers-lib/constants/Products");

var ProductTags = function ProductTags(_ref) {
  var products = _ref.products;
  var filteredProducts = (0, _immutable.Set)();

  if (_Products.SalesEnterpriseParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sales Enterprise');
  } else if (_Products.SalesProfessionalParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sales Professional');
  } else if (_Products.SalesStarterParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sales Starter');
  } else if (_Products.SalesProParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sales Pro');
  } else if (_Products.SalesPowerParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sales Power');
  } else if (_Products.SalesFreeParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sales Free');
  }

  if (_Products.MarketingEnterpriseParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Marketing Enterprise');
  } else if (_Products.MarketingProParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Marketing Pro');
  } else if (_Products.MarketingBasicParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Marketing Basic');
  } else if (_Products.MarketingStarterParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Marketing Starter');
  } else if (_Products.MarketingFreeParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Marketing Free');
  }

  if (_Products.ServiceEnterpriseParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Service Enterprise');
  } else if (_Products.ServiceProfessionalParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Service Professional');
  } else if (_Products.ServiceStarterParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Service Starter');
  } else if (_Products.ServiceFreeParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Service Free');
  }

  if (_Products.StandaloneCMSFreeParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Standalone CMS Free');
  }

  if (_Products.StandaloneCMSPaidParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Standalone CMS Paid');
  }

  if (_Products.SitesParcels.intersect(products).size > 0) {
    filteredProducts = filteredProducts.add('Sites');
  }

  _Products.OtherParcelMappings.forEach(function (displayName, parcel) {
    if (products.contains(parcel)) {
      filteredProducts = filteredProducts.add(displayName);
    }
  });

  var productTags = filteredProducts.sort(function (a, b) {
    return a.length - b.length;
  }).map(function (product) {
    return _react.default.createElement(_UITag.default, {
      key: product
    }, product);
  });
  return _react.default.createElement(_UIList.default, {
    inline: true
  }, productTags);
};

ProductTags.propTypes = {
  products: _propTypes.default.instanceOf(_immutable.Set).isRequired
};
var _default = ProductTags;
exports.default = _default;
module.exports = exports.default;